import React from "react";
import type { Role } from "@meupedaco/shared";
import { CrudPage } from "../../components/CrudPage";

export const FuncoesPage: React.FC = () => {
  return (
    <CrudPage<Role>
      title="Funcoes"
      endpoint="/modules/funcoes"
      searchPlaceholder="Buscar por nome..."
      columns={[
        { label: "Nome", render: (item) => item.name },
        { label: "Descricao", render: (item) => item.description ?? "-" },
        { label: "Ativa", render: (item) => (item.isActive ? "Sim" : "Nao") },
      ]}
      formFields={[
        { name: "name", label: "Nome", type: "text", required: true },
        { name: "description", label: "Descricao", type: "text" },
        { name: "isActive", label: "Ativa", type: "checkbox" },
      ]}
      initialValues={{
        name: "",
        description: "",
        isActive: true,
      }}
      mapToPayload={(values) => ({
        name: values.name,
        description: values.description || null,
        isActive: values.isActive,
      })}
      permissionWrite="CATALOG_ROLES_WRITE"
    />
  );
};
